import React, { useRef } from 'react';

const VideoBanner = () => {
    const videoRef = useRef(null);

    const handleClick = () => {
        const v = videoRef.current;
        if (!v) return;
        if (v.requestFullscreen) v.requestFullscreen();
        else if (v.webkitRequestFullscreen) v.webkitRequestFullscreen();
        v.play();
    };

    return (
        <div className="video-banner2" style={{ padding: 0, overflow: 'hidden', cursor: 'pointer' }} onClick={handleClick}>
            <div className="video-banner-img2" style={{ position: 'relative', lineHeight: 0, height: '100%' }}>
                <video
                    ref={videoRef}
                    src="/assets/video/hero.mp4"
                    style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block', pointerEvents: 'none' }}
                    playsInline
                />
                {/* Play overlay */}
                <div style={{
                    position: 'absolute', inset: 0,
                    display: 'flex', flexDirection: 'column',
                    alignItems: 'center', justifyContent: 'center',
                    gap: 14,
                }}>
                    <div style={{
                        width: 72, height: 72, borderRadius: '50%',
                        background: 'rgba(255,255,255,0.15)',
                        backdropFilter: 'blur(8px)',
                        border: '2px solid rgba(255,255,255,0.4)',
                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                        boxShadow: '0 8px 32px rgba(0,0,0,0.4)',
                        transition: 'transform 0.2s ease',
                    }}>
                        <svg width="26" height="26" viewBox="0 0 24 24" fill="white">
                            <polygon points="5 3 19 12 5 21 5 3" />
                        </svg>
                    </div>
                    <span style={{ color: 'rgba(255,255,255,0.85)', fontSize: 13, fontWeight: 600, letterSpacing: '0.5px' }}>
                        Click to watch fullscreen
                    </span>
                </div>
            </div>
        </div>
    );
};

export default VideoBanner;
